import { USER_FAV_CINEMA_ADD, USER_FAV_CINEMA_REMOVE } from "../../types";

export const addUserFaveCinema = (cinemaId: number) => ({
    type: USER_FAV_CINEMA_ADD,
    cinemaId,
});

export const removeUserFaveCinema = (cinemaId: number) => ({
    type: USER_FAV_CINEMA_REMOVE,
    cinemaId,
});